import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingBackToTop from '@/components/feature/FloatingBackToTop';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedCategories from './components/FeaturedCategories';
import HotProducts from './components/HotProducts';
import BrandStory from './components/BrandStory';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="岛国精品官方精选｜正品保障直邮到家 - 日本原装进口商品推荐"
        description="岛国精品汇聚日本原装进口商品，涵盖美妆护肤、食品零食、家居日用等多品类精选好物。品质严选、正品保障，支持直邮到家，让您轻松享受来自日本的高品质生活体验。立即浏览岛国精品全品类特惠专区。"
        keywords="岛国精品,岛国精品进口好物,岛国精品美妆护肤,岛国精品日本直邮,岛国精品正品保障,日本精选商品推荐,日本原装进口特惠"
        canonicalUrl="https://www.daoguojingpin.com"
      />

      <SchemaOrg type="Organization" data={{
        name: '岛国精品',
        url: 'https://www.daoguojingpin.com',
        description: '岛国精品汇聚日本原装进口商品，涵盖美妆护肤、食品零食、家居日用等多品类精选好物。',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-888-9999',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      }} />

      <SchemaOrg type="WebSite" data={{
        name: '岛国精品',
        url: 'https://www.daoguojingpin.com',
        description: '日本原装进口商品精选平台',
        inLanguage: 'zh-CN',
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedCategories />
          <HotProducts />
          <BrandStory />
          <FAQSection />
          <NewsletterSection />
        </main>
        <Footer />
        <FloatingBackToTop />
      </div>
    </>
  );
}